export const emailLogConstants = {
    GET_EMAIL_LOGS_REQUEST: 'GET_EMAIL_LOGS_REQUEST',
    GET_EMAIL_LOGS_SUCCESS: 'GET_EMAIL_LOGS_SUCCESS',
    GET_EMAIL_LOGS_FAILURE: 'GET_EMAIL_LOGS_FAILURE',

}